<template>
  <section class="sr-container-wrapper">
    <!-- Today/7/30 Day Row -->
    <div class="row">
      <!-- First Box -->
      <div class="col col-md-4 p-3">
        <div class="box box-success">
          <div v-if="!showLoading" class="d-flex justify-space-between">
            <div class="d-flex flex-column w-50">
              <div class="mx-2 my-2">
                <h4 class="mb-1 mt-0">
                  <fai :icon="['fas', 'paper-plane']" class="mb-1 mr-2"/>
                </h4>
                <h5 v-html="thirtyDaysStrAvg" class="mt-1 p-1" />
              </div>
            </div>
            <div class="d-flex justify-center flex-grow">
              <div class="d-flex flex-column justify-space-between flex-grow">
                <div class="d-flex justify-end my-1">
                  <div class="d-flex flex-column justify-center ">
                    <div class="d-flex justify-end">
                      <h5 class="my-0"><span class=""> Messages Sent </span></h5>
                    </div>
                    <div class="d-flex justify-end">
                      <h3 class="countValue my-0 mb-1">
                        <p>{{sums.thirtyDayMsgAvg}}</p>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-end my-1">
                  <div class="d-flex flex-column justify-center">
                    <div class="d-flex justify-end">
                      <h5 class="my-0">
                        <span class=""> Feedback Received </span>
                    </h5>
                    </div>
                    <div class="d-flex justify-end">
                      <h3 class="countValue my-0 mb-1">
                        <p>{{sums.thirtyDayFbkAvg}}</p>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Second Box -->
      <div class="col col-md-4 p-3">
        <div class="box box-success">
          <div v-if="!showLoading" class="d-flex justify-space-between">
            <div class="d-flex flex-column w-50">
              <div class="mx-2 my-2 pb-1">
                <h4 class="mb-1 mt-0">
                  <fai :icon="['fas', 'paper-plane']" class="mb-1 mr-2"/>
                </h4>
                <h5 v-html="sevenDaysStrSum" class="mt-1 p-1" />
              </div>
            </div>
            <div class="d-flex justify-center flex-grow">
              <div class="d-flex flex-column justify-space-between flex-grow">
                <div class="d-flex justify-end my-1">
                  <div class="d-flex flex-column justify-center">
                    <div class="d-flex justify-end">
                      <h5 class="my-0"><span class=""> Messages Sent </span></h5>
                    </div>
                    <div class="d-flex justify-end">
                      <h3 class="countValue my-0 mb-1">
                        <p>{{sums.sevenDayMsgSum}}</p>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-end my-1">
                  <div class="d-flex flex-column justify-center">
                    <div class="d-flex justify-end">
                      <h5 class="my-0">
                        <span class=""> Feedback Received </span>
                    </h5>
                    </div>
                    <div class="d-flex justify-end">
                      <h3 class="countValue my-0 mb-1">
                        <p>{{sums.sevenDayFbkSum}} ({{sums.sevenDayFbkPct}}%)</p>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Third Box -->
      <div class="col col-md-4 p-3">
        <div class="box box-success">
          <div v-if="!showLoading" class="d-flex justify-space-between">
            <div class="d-flex flex-column w-50">
              <div class="mx-2 my-2 pb-1">
                <h4 class="mb-1 mt-0">
                  <fai :icon="['fas', 'paper-plane']" class="mb-1 mr-2"/>
                </h4>
                <h5 v-html="thirtyDaysStrSum" class="mt-1 p-1" />
              </div>
            </div>
            <div class="d-flex justify-center flex-grow">
              <div class="d-flex flex-column justify-space-between flex-grow">
                <div class="d-flex justify-end my-1">
                  <div class="d-flex flex-column justify-center">
                    <div class="d-flex justify-end">
                      <h5 class="my-0"><span class=""> Messages Sent </span></h5>
                    </div>
                    <div class="d-flex justify-end">
                      <h3 class="countValue my-0 mb-1">
                        <p>{{sums.thirtyDayMsgSum}}</p>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-end my-1">
                  <div class="d-flex flex-column justify-center">
                    <div class="d-flex justify-end">
                      <h5 class="my-0">
                        <span class=""> Feedback Received </span>
                    </h5>
                    </div>
                    <div class="d-flex justify-end">
                      <h3 class="countValue my-0 mb-1">
                        <p>{{sums.thirtyDayFbkSum}} ({{sums.thirtyDayFbkPct}}%)</p>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Line Row -->
    <div class="row">
      <div class="col-sm-12"><hr style="margin:10px 10px" /></div>
    </div>

    <!-- Chart Row -->
    <div class="row">
      <div class="col-xs-12">
        <div class="d-flex justify-center" v-if="showLoading">
          <sb-loading-icon />
        </div>
        <MessagesChart
          v-else-if="surveys.length != 0"
          :feedback="surveys.feedback"
          :messages="surveys.messages"
          :refreshTrigger="refreshTrigger"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { feedbackAPI } from "../../../../services/api/feedbackAPI"
import MessagesChart from '../../../Graphs/MessagesChart'

export default {
  name: "SentReceivedContainer",
  components: {
    MessagesChart
  },
  data() {
    return {
      surveys: [],
      sums: [],
      refreshTrigger: false,
      showLoading: true,
      dataConfig: {
        params: {
          days: 30
        }
      }
    };
  },
  async created() {
    this.surveys = await feedbackAPI.GETSentAndReceived(this.dataConfig)
    this.$root.$on("setStore", () => {
      this.refresh()
    });
    this.showLoading = false
  },
  computed: {
    thirtyDaysStrAvg() {
      let { sums } = this
      const baseText = 'average message sent and feedback received over the past '
      if (sums.length != 0 && sums.maxDays == 1) {
        return `${baseText} day`
      } else if (sums.length != 0) {
        return `${baseText} <b>${sums.maxDays}</b> days`
      } else {
        return `${baseText} <b>30</b> days`
      }
    },
    thirtyDaysStrSum() {
      let { sums } = this
      const baseText = 'total message sent and feedback received over the past '
      if (sums.length != 0 && sums.maxDays == 1) {
        return `${baseText} day`
      } else if (sums.length != 0) {
        return `${baseText} <b>${sums.maxDays}</b> days`
      } else {
        return `${baseText} <b>30</b> days`
      }
    },
    sevenDaysStrSum() {
      let { sums } = this
      const baseText = 'total message sent and feedback received over the past '
      if (sums.length != 0 && sums.maxDays == 1) {
        return `${baseText} day`
      } else if (sums.length != 0 && sums.maxDays < 7) {
        return `${baseText} <b>${sums.maxDays}</b> days`
      } else {
        return `${baseText} <b>7</b> days`
      }
    }
  },
  methods: {
    refresh: async function() {
      this.showLoading = true

      this.surveys = await feedbackAPI.GETSentAndReceived(this.dataConfig)

      this.refreshTrigger = !this.refreshTrigger
      this.showLoading = false
    },
    CommafyNumber: function(int) {
      return int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  watch: {
    surveys: function(val) {
      let { surveys } = this
      if(surveys.length == 0) return

      const maxDays = surveys.messages.length
      const msg30 = surveys.messages.reduce((a,b)=>a+b.count, 0)
      const fbk30 = surveys.feedback.reduce((a,b)=>a+b.count, 0)
      const msg7 = surveys.messages.slice(-7).reduce((a,b)=>a+b.count, 0)
      const fbk7 = surveys.feedback.slice(-7).reduce((a,b)=>a+b.count, 0)

      this.sums = {
        'maxDays': maxDays,
        'thirtyDayMsgAvg': this.CommafyNumber(Math.round(msg30 / maxDays)),
        'thirtyDayFbkAvg': this.CommafyNumber(Math.round(fbk30 / maxDays)),
        'thirtyDayMsgSum': this.CommafyNumber(msg30),
        'thirtyDayFbkSum': this.CommafyNumber(fbk30),
        'thirtyDayFbkPct': Math.round(100 * fbk30 / msg30),
        'sevenDayMsgSum': this.CommafyNumber(msg7),
        'sevenDayFbkSum': this.CommafyNumber(fbk7),
        'sevenDayFbkPct': Math.round(100 * fbk7 / msg7)
      }
    }
  }
};
</script>